module.exports = __webpack_public_path__ + "static/media/WISENE_logo_big.9c71229b.png";